var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"main",attrs:{"id":"app"}},[_c('headerTop'),(_vm.btnFlag)?_c('div',{staticClass:"img_top",on:{"click":_vm.backTop}}):_vm._e(),_c('div',{ref:"empty",staticClass:"empty"}),_c('router-view'),_c('footerBottom')],1)}
var staticRenderFns = []

export { render, staticRenderFns }